/* bs-yt: YouTube clips that behave like ambient video.
   Each .bs-yt[data-yt] loads its player when it nears the screen, plays muted with captions off (Oct 22), pauses when it
   scrolls away, and keeps its poster up until the video is actually playing (data-hold = minimum ms to show it).
   One tap turns the sound on; a second tap mutes. Only one clip has sound at a time.
   Talks to the player over postMessage (enablejsapi), so no YouTube script is loaded. Nothing opens a modal. */
(function () {
  'use strict';
  if (!('IntersectionObserver' in window)) return;
  var players = [];
  function cmd(f, func, args) {
    if (!f || !f.contentWindow) return;
    f.contentWindow.postMessage(JSON.stringify({ event: 'command', func: func, args: args || [] }), '*');
  }
  function build(el) {
    if (el.dataset.live) return;
    el.dataset.live = '1';
    var id = el.dataset.yt, start = parseInt(el.dataset.start || '0', 10) || 0;
    var q = 'enablejsapi=1&autoplay=1&mute=1&playsinline=1&controls=0&rel=0&modestbranding=1&iv_load_policy=3&disablekb=1' +
      '&cc_load_policy=0&loop=1&playlist=' + id + (start ? '&start=' + start : '') + '&origin=' + encodeURIComponent(location.origin);
    var f = document.createElement('iframe');
    f.src = 'https://www.youtube-nocookie.com/embed/' + id + '?' + q;
    f.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
    f.allowFullscreen = true; f.title = el.getAttribute('aria-label') || 'Video'; f.tabIndex = -1;
    el.insertBefore(f, el.firstChild);
    var p = { el: el, f: f, born: Date.now(), hold: parseInt(el.dataset.hold || '0', 10) || 0, playing: false, sound: false, shown: false };
    players.push(p);
    f.addEventListener('load', function () {
      f.contentWindow.postMessage(JSON.stringify({ event: 'listening', id: id }), '*');
      cmd(f, 'mute'); cmd(f, 'playVideo');
    });
  }
  function reveal(p) {
    if (p.shown) return;
    var wait = Math.max(0, p.hold - (Date.now() - p.born));
    setTimeout(function () { p.shown = true; p.el.classList.add('is-playing'); }, wait);
  }
  window.addEventListener('message', function (e) {
    if (typeof e.data !== 'string' || e.origin.indexOf('youtube') < 0) return;
    var d; try { d = JSON.parse(e.data); } catch (err) { return; }
    if (!d || !d.info) return;
    players.forEach(function (p) {
      if (p.f.contentWindow !== e.source) return;
      if (d.info.playerState === 1) { p.playing = true; reveal(p); }
    });
  });
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      var el = en.target;
      if (en.isIntersecting) {
        build(el);
        var p = players.filter(function (x) { return x.el === el; })[0];
        if (p && p.playing) cmd(p.f, 'playVideo');
      } else {
        var q = players.filter(function (x) { return x.el === el; })[0];
        if (q) { cmd(q.f, 'pauseVideo'); if (q.sound) { cmd(q.f, 'mute'); q.sound = false; el.classList.remove('has-sound'); } }
      }
    });
  }, { rootMargin: '240px 0px' });
  document.querySelectorAll('.bs-yt[data-yt]').forEach(function (el) { io.observe(el); });
  document.addEventListener('click', function (e) {
    var el = e.target.closest('.bs-yt[data-yt]'); if (!el) return;
    e.preventDefault();
    build(el);
    var p = players.filter(function (x) { return x.el === el; })[0]; if (!p) return;
    if (p.sound) { cmd(p.f, 'mute'); p.sound = false; el.classList.remove('has-sound'); return; }
    players.forEach(function (o) { if (o !== p && o.sound) { cmd(o.f, 'mute'); o.sound = false; o.el.classList.remove('has-sound'); } });
    cmd(p.f, 'unMute'); cmd(p.f, 'setVolume', [100]); cmd(p.f, 'playVideo');
    p.sound = true; el.classList.add('has-sound'); p.shown = true; el.classList.add('is-playing');
  });
})();
